export default {
  title: {
    en: 'YOU\'VE SUCCESSFULLY REACTIVATED!',
  },

  textStart: {
    en: 'Great to have you back.',
  },

  textDefault: {
    en: `
    If you're ready<br class="onlyMobile" /> for a refresh,<br class="exceptMobile" />
    our scent quiz is a great<br class="onlyMobile" /> place to start again.
  `,
  },
  text5off: {
    en: 'Enjoy $5 off this month\'s subscription charge!',
  },
  text50off: {
    en: 'Enjoy 50% off this month\'s subscription charge!',
  },
  textFree: {
    en: 'You\'ll receive the next item in your queue FREE of charge.',
  },
  textCase: {
    en: 'Enjoy a free Scentbird case on us!',
  },

  buttonQuiz: {
    en: 'Take scent quiz',
  },
  buttonSkip: {
    en: `I'll just explore on my own`,
  },
}
